module.exports = __webpack_public_path__ + "img/chat-file-message-clip.bdc865c6.svg";